import React from 'react';
import { getPasswordStrength } from './../../authentication/utils/validation';
import { CloseOutlined, Done } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { simplifiedAuthStyles } from './../styles/simplifiedAuth';
import { useTranslation } from 'react-i18next';
import { PASSWORD_MIN_LENGTH } from './../constants/authConstant';

export const PasswordStrengthMessages = (props: { password: string }): React.JSX.Element => {
  const { password } = props;
  const { classes } = simplifiedAuthStyles();
  const { t } = useTranslation();

  const passwordValidations = { validCharCount: true, validVariations: true };

  if (password !== '') {
    const passwordStrength = getPasswordStrength(password);

    if (passwordStrength.charCount < PASSWORD_MIN_LENGTH) {
      passwordValidations.validCharCount = false;
    }
    if (
      !passwordStrength.variations.upper ||
      !passwordStrength.variations.lower ||
      !passwordStrength.variations.digits
    ) {
      passwordValidations.validVariations = false;
    }
  }

  return (
    <>
      {password.length === 0 ? (
        <ul className={classes.passwordMsgList}>
          <li>{t('simplifiedPasswordValidation1')}</li>
          <li>{t('simplifiedPasswordValidation2')}</li>
        </ul>
      ) : (
        <Box>
          <Typography
            className={`${classes.passwordValidation} ${
              passwordValidations.validCharCount ? classes.successText : classes.errorText
            }`}>
            {passwordValidations.validCharCount ? (
              <Done width="10px" height="10px" className={classes.successText} />
            ) : (
              <CloseOutlined width="10px" height="10px" className={classes.errorText} />
            )}
            &nbsp;{t('simplifiedPasswordValidation1')}
          </Typography>
          <Typography
            className={`${classes.passwordValidation} ${
              passwordValidations.validVariations ? classes.successText : classes.errorText
            }`}>
            {passwordValidations.validVariations ? (
              <Done width="10px" height="10px" className={classes.successText} />
            ) : (
              <CloseOutlined width="10px" height="10px" className={classes.errorText} />
            )}
            &nbsp;{t('simplifiedPasswordValidation2')}
          </Typography>
        </Box>
      )}
    </>
  );
};
